module.exports = __webpack_public_path__ + "view/img/productC.e8bbde7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shj/productC.png
// module id = cPfI
// module chunks = 0